import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import * as _ from "lodash";
import { ToastService } from "ng-uikit-pro-standard";
import { ConsoleService } from "src/app/shared/services/console.service";
import { SecurityService } from "src/app/shared/services/security.service";
import { ModalAgregarDocumentoComponent } from './modal-agregar-documento/modal-agregar-documento/modal-agregar-documento.component';
import { FormValidatorsService } from "src/app/shared/services/form-validators.service";
import { DatesService } from "src/app/shared/services/dates.service";
import { MessageRendererService } from "src/app/services/message-renderer.service";
import { DocumentoRecepcionadoService } from "src/app/services/documento-recepcionado.service";
import { PaginationContext } from "src/app/shared/object/pagination_context.model";
import { RutService } from "src/app/shared/services/rut.service";
import { FileDownloadService } from "src/app/shared/services/file-download.service";

@Component({
  selector: 'app-docs-recibidos-manualmente',
  templateUrl: './docs-recibidos-manualmente.component.html',
  styleUrls: ['./docs-recibidos-manualmente.component.scss'],
  providers: [SecurityService]
})
export class DocsRecibidosManualmenteComponent implements OnInit {

  // Modales
  @ViewChild(ModalAgregarDocumentoComponent, { static: true }) modalAgregarDoc: ModalAgregarDocumentoComponent

  // Form
  formHeader: FormGroup

  // Data & tmp
  private rutEmpresa: number
  private sucursalCodigo: number

  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];

  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];


  // Utils
  private log: any
  loading: boolean = false;
  paginationContext: PaginationContext = new PaginationContext();
  listaMovimientos: Array<any> = null;
  listaMovimientosAll: Array<any> = null;
  private currentPayload: any = null

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private datesService: DatesService,
    private messageRendererService: MessageRendererService,
    private documentoRecepcionadoService: DocumentoRecepcionadoService,
    private rutService: RutService,
    private fileDownloadService: FileDownloadService
  ) { this.log = this.clog.log('DOC. RECIBIDOS MANUALMENTE') }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 15
    //this.loadMonths();
    //this.loadYears();
    this.createForm();
    //this.setDefaults();
  }

  loadMonths() {
    this.optionsMonth = this.datesService.GetCurrentMonths('desc')
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears()
  }


  setDefaults() {
    if (this.optionsMonth.length > 0)
      this.formHeader.get('mes').setValue(this.optionsMonth[0].value)
    if (this.optionsYear.length > 0)
      this.formHeader.get('anho').setValue(this.optionsYear[0].value)
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formHeader = this.fb.group({
      fechaDesde: [initDate, [Validators.required]],
      fechaHasta: [currentDate, [Validators.required]],
    });
  }
  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid) {
    //   return
    // }

    this.paginationContext.CurrentPage = pageNumber

    const { fechaDesde, fechaHasta } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        fecha_desde: fechaDesde,
        fecha_hasta: fechaHasta,
        tipo_dte_codigo: 33
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1
    }

    this.currentPayload = inputParams


    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.listaMovimientos = null
    this.listaMovimientosAll = null

    this.documentoRecepcionadoService.obtenerDocRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta

      this.listaMovimientosAll = registros
      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      this.paginationContext.CurrentPage = pageNumber
      this.listaMovimientosAll.forEach((mov, index) => {
        mov.additionalInfo = {}
        mov.rutFormato = this.rutService.AgregarDV(mov.rut_emisor)
      })
      // this.paginationContext.RecordsCount = totalRegistros
      // this.paginationContext.PagesCount =  totalPaginas
      // this.paginationContext.CurrentPage = paginaActual
      this.showPage(this.paginationContext.CurrentPage)
      this.loading = false
    })
  }


  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  OpenagregarDoc() {
    this.modalAgregarDoc.show()
  }

  getItemToSearch($event) {
    this.buscar($event);
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoRecepcionadoService.obtenerDocRecepcionadoExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].rutaArchivo)
    })
  }

}
